module.exports = __webpack_public_path__ + "static/element-software-logo-name-light-d44689a62de48087bd6af7cb6aa089b9.png";